<template>
  <ym-loadmore v-model="block.loading"
               :finished="block.allLoad"
               @load="fetchData"
  >
    <list :list="block.list"
          :show-empty="block.allLoad"
    />
  </ym-loadmore>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import List from '@/components/ProductList/List';
  import { getRankingList } from '@/services/ranking';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'RankingProductList',
    components: {
      'ym-loadmore': Loadmore,
      List,
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
    },
    methods: {
      generateList(list) {
        return list.map((item) => {
          item.render.mark = null;
          return item;
        });
      },
      async fetchData() {
        if (this.block.allLoad) return;
        this.block.loading = true;

        const { block: { start, type: productType } } = this;
        const data = await getRankingList({
          start,
          productType,
          limit: LIMIT,
        }, true);

        if (data.list.length === 0) {
          this.block.allLoad = true;
          this.block.loading = false;
          return;
        }

        this.block.start = data.start;
        this.block.list = [...this.block.list, ...this.generateList(data.list)];

        this.block.loading = false;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ranking-product-list {
    padding: 0 @size-base;
  }

  .list-item {
    margin-bottom: @size-large;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .seq,
  .icon {
    flex-shrink: 0;
    margin-right: @size-small;
    width: @size-medium;
    height: @size-extra-medium;
  }

  .seq {
    padding-top: @size-extra-small + @size-extra-small / 2;
    position: relative;
    font-size: @font-size-medium;
    font-weight: @font-weight-bold;
    color: @color-text-base;
    text-align: center;
    &:before {
      width: 36px;
      height: 6px;
      position: absolute;
      content: '';
      background: @color-gray-lighter;
      left: 0;
      top: 0;
    }
  }

  .icon {
    &.gold {
      background: url('~@/assets/img/ranking/gold.png') no-repeat;
      background-size: contain;
    }
    &.silver {
      background: url('~@/assets/img/ranking/silver.png') no-repeat;
      background-size: contain;
    }
    &.bronze {
      background: url('~@/assets/img/ranking/bronze.png') no-repeat;
      background-size: contain;
    }
  }

  .item-content {
    flex: 1;
    display: flex;
    overflow: hidden;
  }

  .cover {
    margin-right: @size-base;
  }

  .item-info {
    width: 406px;
  }

  .title {
    margin-bottom: @size-extra-small;
    font-weight: @font-weight-bold;
    font-size: @font-size-base;
    color: @color-text-base;
    line-height: 1.4;
  }

  .summary {
    font-size: @font-size-small;
    color: @color-text-light;
  }

</style>
